import React, { useEffect, useState } from 'react'
import './style.css'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { subscribe } from 'Redux/reminder/reminder.actions'
import environment from 'environments/environment'
import { Typography } from '@material-ui/core'

export default function Subscribed() {

    let { id } = useParams()
    const dispatch = useDispatch()
    const { subscribeResponse } = useSelector(
        (state) => state.reminder,
      )

    useEffect(()=>{
        if(id){
          dispatch(subscribe(id))
        }
    },[id])

    const clinicName = subscribeResponse?.data?.clinicName
    const clinicPhone = subscribeResponse?.data?.clinicPhone
    const clinicEmail = subscribeResponse?.data?.clinicEmail

  return (
    <div className="sub-page">
      <div className="sub-outer">
        <div className="sub-card">
          <div className="sub-accent" />

          <h1 className="sub-title">You’re Subscribed Again</h1>

          <p className="sub-confirm">
            Your email preferences have been successfully updated. You are now
            re-subscribed to receive communications from{' '}
            <strong>{clinicName}</strong>.
          </p>

          <p className="sub-message">
            You’ll continue receiving important updates such as appointment
            reminders, virtual check-in notifications, and helpful wellness
            information.
          </p>

          <div className="sub-pill">
            A confirmation email has been sent for your records.
          </div>

          <div className="sub-divider" />

          <div className="sub-contact">
            <h2 className="sub-contact-title">Need Assistance?</h2>

            <div className="sub-contact-box">
              <p className="sub-contact-line sub-contact-strong">
                <strong>{clinicName}</strong>
              </p>

              {
                clinicPhone && (
                  <p className="sub-contact-line">
                    Phone:{' '}
                    <a href={`tel:${clinicPhone}`} className="sub-link">
                      {clinicPhone}
                    </a>
                  </p>
                )
              }

              {
                clinicEmail && (
                  <p className="sub-contact-line">
                    Email:{' '}
                    <a href={`mailto:${clinicEmail}`} className="sub-link">
                      {clinicEmail}
                    </a>
                  </p>
                )
              }
            </div>
          </div>
        </div>

        <div className="sub-footer">
          <Typography
            variant="caption"
            align="center"
            color="textSecondary"
            display="block"
          >
            © {new Date().getFullYear()}–{new Date().getFullYear() + 1}{' '}
            {environment.companyName}. All rights reserved.
            <div>
              {environment.copyRight}
              <br />
              Unauthorized access, use, or reproduction of this application or
              its contents is strictly prohibited.
            </div>
          </Typography>
        </div>
      </div>
    </div>
  )
}
